import React, { Component, Fragment } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'

import Button from '../Button/Button'
import ButtonLink from '../Button/ButtonLink'
import Link from '../typography/Link'
import Modal from '../../Modal'
import Input from '../Input'
import Heading4 from '../typography/Heading4'
import RDGateway from '../../../gateways/RDGateway'
import { telephoneMask } from '../../../utils/masks'

const FIELDS = ['name', 'email', 'telephone', 'activity']

const ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
}

class RDForm extends Component {
    static propTypes = {
        b2b: PropTypes.bool,
        contaAzul: PropTypes.bool,
        className: PropTypes.string,
        radius: PropTypes.string,
        partnerId: PropTypes.string,
    }

    static defaultProps = {
        b2b: false,
        contaAzul: false,
        radius: 'half-rounded',
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)

    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            name: '',
            email: '',
            telephone: '',
            activity: '',
            typingTimeout: 0,
            partnerId: props.partnerId
        }
        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })
        return initialObject
    }

    setDataByCookie() {
        this.setState({
            partnerId: Cookies.get('leaderPartnerId') || this.state.partnerId || ''
        })
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false
        })
    }

    handleChange(e) {
        const name = e.target.id
        let value = e.target.value

        if (name === 'telephone') {
            value = telephoneMask(value)
        } else if (name === 'name') {

        } else if (name === 'email') {

        } else if (name === 'activity') {
        }

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout)
        }

        this.setState({
            [name]: value,
            [`${name}Error`]: false,
            [`${name}Typing`]: true,
            typingTimeout: setTimeout(() => {
                if (name === 'email' && this.validateEmail(this.state.email)) {
                }
            }, 3000)
        })
    }

    handlerEnterpriseActivity(tipo) {
        this.setState({ 'activity': tipo })
    }

    handlerEnterpriseActivitySelect(e) {
        this.setState({ selectValue: e.target.value })
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected ? 'active' : ''
    }



    validation() {

        const newState = {}

        const regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        FIELDS.forEach(campo => {
            if (!this.props.kitClientes) {
                newState[`${campo}Error`] = !this.state[campo]
            }

            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'telephone': {
                    if (this.props.kitClientes) {
                        break
                    }
                    newState[`${campo}Error`] = !regexTelephone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(email.toLowerCase())
    }

    submitForm(e) {
        e.preventDefault()

        if (this.validation()) {
            const data = {
                conversion_identifier: this.props.kitClientes ? 'kit-clientes-inativos' : 'inscreveu-imersao-vendas-atacado',
                'cf_tipo_de_conversao': this.props.kitClientes ? 'Acessou o kit de clientes inativos' : 'Inscreveu na Imersão em Vendas para o Atacado',
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.telephone,
                'cf_atividade_da_empresa': this.state.activity,
                event_action: this.props.kitClientes ? 'download' : '',
                event_label: this.props.kitClientes ? 'kit-clientes-inativos' : '',
            }
            
            let redirectLink = this.props.kitClientes ? '/materiais/tp-kit-clientes-inativos' : 'https://mercos.com/tp/tp-imersao-vendas-atacado/'

            this.rdGateway.sendToRDStation(data, redirectLink)
        }
    }

    componentDidMount() {
        this.setDataByCookie()

        var handler = function () {
            var visible = document.documentElement.scrollTop >= (window.innerHeight - 200);
            if (visible) {
                document.getElementById("root").classList.add("show-bt-fixo");
            } else document.getElementById("root").classList.remove("show-bt-fixo");

        };
        globalThis.addEventListener("load", handler);
        globalThis.addEventListener("resize", handler);
        globalThis.addEventListener("scroll", handler);


    }


    getDemoModal() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()}>
                <div className='container-form-modal'>
                    <Heading4 className="form-title">Garanta a sua vaga! Preencha o formulário para realizar sua inscrição</Heading4>
                    <form action='.' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>

                        <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus placeholder='Seu Nome' />

                        <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder='Email' />

                        <Input id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder='Telefone' />

                        <label style={{ marginTop: '20px' }}>Qual é a atividade da sua empresa?</label>



                        <div className='group-buttons'>
                            <Button model='outline' className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.industria)}>Indústria</Button>
                            <Button model='outline' className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.distribuicao)}>Distribuição</Button>
                            <Button model='outline' className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.rep)}>Representante comercial</Button>
                            <Button model='outline' className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.outra)}>Outra</Button>
                            {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                        </div>

                        <div className='submit-demo-modal'>
                            <Button type='submit' radius={this.props.radius} className={this.props.className}>Inscreva-se Gratuitamente</Button>
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }


    desktopFullForm() {
        return (
            <div className='container-form-desktop'>
                <form action='.' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>

                    <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus placeholder='Seu Nome' />

                    <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder='Email' />

                    <Input id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder='Telefone' />

                    <label style={{ marginTop: '20px' }}>Qual é a atividade da sua empresa?</label>

                    <div className='group-buttons'>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.industria)}>Indústria</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.distribuicao)}>Distribuição</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.rep)}>Representante comercial</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.outra)}>Outra</Button>
                        {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                    </div>


                    <div className='submit-demo-modal'>
                        <Button type='submit' radius={this.props.radius} className={this.props.className}>{this.props.buttonText ? this.props.buttonText : 'Inscreva-se Gratuitamente'}</Button>
                    </div>
                </form>
            </div>
        )
    };

    kitClientesForm() {
        return (
            <div className='container-form-desktop'>
                <form action='.' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>

                    <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus placeholder='Seu Nome' />

                    <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder='Email' />

                    <label style={{ marginTop: '20px' }}>Qual é a atividade da sua empresa?</label>

                    <div className='group-buttons'>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.industria)}>Indústria</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.distribuicao)}>Distribuição</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.rep)}>Representante comercial</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.outra)}>Outra</Button>
                        {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                    </div>


                    <div className='submit-demo-modal'>
                        <Button type='submit' radius={this.props.radius} className={this.props.className}>{this.props.buttonText ? this.props.buttonText : 'Inscreva-se Gratuitamente'}</Button>
                    </div>
                </form>
            </div>
        )
    };

    desktopForm() {
        return (
            <div className='container-form-desktop'>
                <form action='.' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>

                    <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus placeholder='Seu Nome' />

                    <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder='Email' />

                    <Input id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder='Telefone' />



                    <select className='input all-rounded' name="activity" id="activity" value={this.state.selectValue} onChange={e => this.handleChange(e)}>
                        <option value="">Qual é a atividade da sua empresa?</option>
                        <option value="industria">Indústria</option>
                        <option value="distribuicao">Distribuição</option>
                        <option value="rep">Representante comercial</option>
                        <option value="outra">Outra</option>
                    </select>
                    {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}


                    <div className='submit-demo-modal'>
                        <Button type='submit' radius={this.props.radius} className={this.props.className}>Inscreva-se Gratuitamente</Button>
                    </div>
                </form>
            </div>
        )
    };



    render() {
        return (
            <Fragment>
                {this.props.desktopModal ? this.desktopForm() : ''}
                {this.props.desktopFull ? this.desktopFullForm() : ''}
                {this.props.kitClientes ? this.kitClientesForm() : ''}

                {this.props.isLink ?
                    <Fragment>
                        <Link
                            href='.'
                            color={this.props.color}
                            className={this.props.className}
                            onClick={e => this.openDemoModal(e)}
                            title='Inscreva-se Gratuitamente'
                        >
                            {this.props.b2b ? <Fragment>E-commerce B2B <br />opcional, com preço sob consulta.</Fragment> : <span style={{ whiteSpace: 'nowrap' }}>peça uma demonstração</span>}
                        </Link>
                        {this.state.showDemoModal && this.getDemoModal()}
                    </Fragment>
                    :
                    <div className="fixed-bt">
                        <ButtonLink
                            href='.'
                            className={"button-display-modal-rd " + (this.props.className ? this.props.className : '')}
                            onClick={e => this.openDemoModal(e)}
                            title='Inscreva-se.'
                            radius={this.props.radius}
                        >
                            {this.props.children || 'Inscreva-se Gratuitamente'}
                        </ButtonLink>
                    </div>

                }
                {this.state.showDemoModal && this.getDemoModal()}
            </Fragment>
        )
    }
}

export default RDForm



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/RDForm/RDForm.jsx